import Http from '../api/http';

export default class SalesCommission extends Http {
  constructor() {
    super();
  }
  /***********销售提成配置***************/
  /**
   * 提成配置列表
   * @param {string} companyName - 企业名称
   * @param {integer} page - 页码
   * @param {string} recommenderName - 推荐人姓名
   * @param {integer} rows - 每页条数
   * @param {string} signerName - 签约人姓名
   */
  salesCommissionConfig_list() {
    return super.post('company/salesCommissionConfig/list', ...arguments);
  }
  /**
   * 导出提成配置列表
   * @param {string} companyName - 企业名称
   * @param {integer} page - 页码
   * @param {string} recommenderName - 推荐人姓名
   * @param {integer} rows - 每页条数
   * @param {string} signerName - 签约人姓名
   */
  salesCommissionConfig_exportSalesCommissionList() {
    return super.post('company/salesCommissionConfig/exportSalesCommissionList', ...arguments);
  }
  /**
   * 新增提成配置
   * @param {string} companyId - 企业Id
   * @param {string} endTime - 提成结束月
   * @param {string} id - 提成id（修改时必传，新增可不传）
   * @param {Array} recommenderList - 推荐人列表（最多10人），元素：{ distributionRatio: 分配比例(%), uid: 人员id, userName: 人员姓名 }
   * @param {Array} signerList - 签约人列表（最多10人），元素：{ distributionRatio: 分配比例(%), uid: 人员id, userName: 人员姓名 }
   * @param {string} startTime - 提成起始月
   */
  salesCommissionConfig_add() {
    return super.post('company/salesCommissionConfig/add', ...arguments);
  }
  /**
   * 删除提成配置
   * @param {string} id - 提成id
   */
  salesCommissionConfig_delete() {
    return super.post('company/salesCommissionConfig/delete', ...arguments);
  }
  /**
   * 提成配置详情
   * @param {string} id - 提成id
   */
  salesCommissionConfig_detail() {
    return super.post('company/salesCommissionConfig/detail', ...arguments);
  }
  /**
   * 修改提成配置
   * @param {string} companyId - 企业Id
   * @param {string} endTime - 提成结束月
   * @param {string} id - 提成id（必传）
   * @param {Array} recommenderList - 推荐人列表（最多10人），元素：{ distributionRatio: 分配比例(%), uid: 人员id, userName: 人员姓名 }
   * @param {Array} signerList - 签约人列表（最多10人），元素：{ distributionRatio: 分配比例(%), uid: 人员id, userName: 人员姓名 }
   * @param {string} startTime - 提成起始月
   */
  salesCommissionConfig_update() {
    return super.post('company/salesCommissionConfig/update', ...arguments);
  }
}
